module.exports = __webpack_public_path__ + "img/coverimg1.f0c12eaf.png";